import {
  SET_SHORTLINK_DATA,
  RESET_SHORTLINK_STATE,
  SET_TEMPLATE_SHORTLINK_DATA,
  SET_PURCHASED_MEMBERSHIP_SHORTLINK_DATA,
  SET_SUBSCRIBED_MEMBERSHIPS,
} from "../types";

const initialState = {
  initData: {},
  initTemplateData: {},
  purchasedMembDets: {},
  subscribedMemberships: [],
  subscribedMembershipIds: [],
};

const shortLinkReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SHORTLINK_DATA:
      return {
        ...state,
        initData: action.payload,
      };
    case SET_PURCHASED_MEMBERSHIP_SHORTLINK_DATA:
      return {
        ...state,
        purchasedMembDets: action.payload,
      };
    case SET_SUBSCRIBED_MEMBERSHIPS:
      return {
        ...state,
        subscribedMemberships: action.payload ?? [],
        subscribedMembershipIds:
          action?.payload?.map((memb) => memb?.membership_id) ?? [],
      };
    case SET_TEMPLATE_SHORTLINK_DATA:
      return {
        ...state,
        initTemplateData: action.payload,
      };
    case RESET_SHORTLINK_STATE:
      return initialState;
    default:
      return state;
  }
};

export default shortLinkReducer;
